module.exports = new __parcel__URL__("loading_screen_prog_4.2bad3b2e.png").toString();